module.exports = __webpack_public_path__ + "img/icon-40.65163807.jpg";